import { ChangeDetectionStrategy, Component, forwardRef, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { ModalHeaderComponent } from '@base/components/private/modals/modal-header/modal-header.component';
import { ModalBodyComponent } from '@base/components/private/modals/modal-body/modal-body.component';
import { ModalFooterComponent } from '@base/components/private/modals/modal-footer/modal-footer.component';
import { ModalService } from '@base/services/private/modal.service';
import { TranslatePipe } from '@base/pipes/private/translate.pipe';
import { GlobalService } from '@base/services/private/global.service';

@Component({
  selector: 'app-modal-info-meeting-new-tab',
  imports: [ModalHeaderComponent, ModalBodyComponent, ModalFooterComponent, forwardRef(() => TranslatePipe)],
  templateUrl: './modal-info-meeting-new-tab.component.html',
  styleUrl: './modal-info-meeting-new-tab.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalInfoMeetingNewTabComponent implements OnInit, OnDestroy {
  private readonly modalSrv = inject(ModalService);
  private readonly globalSrv = inject(GlobalService);

  @Input() modalId = '';

  ngOnInit(): void {
    setTimeout(() => {
      this.close();
    }, 8000);
  }

  ngOnDestroy(): void {
    this.globalSrv.destroyModalRef(this.modalId);
  }

  /**
   * Closes the modal by invoking the ModalService with the modal ID.
   * @returns void
   */
  close(): void {
    this.modalSrv.close(this.modalId);
  }
}
